// extracted by mini-css-extract-plugin
module.exports = {"title":"AboutModal_title__1fWE6","field":"AboutModal_field__GqIs1","label":"AboutModal_label__2-mIT","value":"AboutModal_value__1p-Gh"};